import { Language } from '@borg/types';

class LanguagesRepository extends Repository<Language> {
  getMany() {
    return this._getMany({ url: '/apps/languages' });
  }
}

export const languagesRepository = new LanguagesRepository();
